import React from "react";
import { Link } from "react-router-dom";
import themeLarge from "../component/ThemeLarge";
import Footer from "../component/Footer";

const Unauthorized = () => {
  return (
    <>
      <div style={styles.container}>
        <h1
          style={{
            fontFamily: "Noto Sans",
            color: themeLarge.colors.primary,
            fontSize: themeLarge.fontSize.display,
          }}
        >
          401 - Unauthorized!
        </h1>
        <p style={styles.text}>
          You do not have access to this page. Please log in.
        </p>
        <Link
          to="/login"
          style={{
            color: themeLarge.colors.text,
            textDecoration: "underline",
            fontSize: themeLarge.fontSize.h4,
          }}
        >
          Go Back to Login
        </Link>
      </div>

      <Footer />
    </>
  );
};

// Inline styles for the component
const styles = {
  container: {
    textAlign: "center",
    height: "80vh",
    paddingTop: "100px",
    background: themeLarge.colors.bg,
  },
  header: {
    fontSize: "48px",
    color: "#333",
  },
  text: {
    fontSize: "18px",
    color: "#777",
  },
  link: {
    fontSize: "18px",
    color: "#007bff",
    textDecoration: "none",
    marginTop: "20px",
    display: "inline-block",
  },
};

export default Unauthorized;
